import { lazy } from 'react'

import { Page } from '@webapp/core/components/Page'
import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'

const DiscoverBillPayViewChunk = lazy(() =>
  import('@webapp/modules/payments/feature-sets/DiscoverBillPayView').then(
    ({ DiscoverBillPayView }) => ({
      default: DiscoverBillPayView,
    })
  )
)

export const DiscoverBillPayPage = () => {
  const intl = useProcurifyIntl()

  return (
    <Page
      pageTitle={intl.formatMessage(messages.discoverBillPayPageTitle)}
      breadcrumbs={[]}
    >
      <DiscoverBillPayViewChunk />
    </Page>
  )
}

DiscoverBillPayPage.displayName = 'DiscoverBillPayPage'
